var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.2835 16.9117c7.5096 0 11.6475-6.2069 11.6475-11.5709v-.5364c.7663-.613 1.456-1.3027 2.069-2.1456-.7663.3066-1.5326.5364-2.3755.613.8429-.5363 1.456-1.3026 1.7625-2.2988-.7663.4598-1.6859.843-2.6054.9962-.7663-.7663-1.8391-1.3027-2.9885-1.3027-2.2222 0-4.0613 1.839-4.0613 4.0613 0 .3065 0 .613.0766.9196-3.3716-.0767-6.4368-1.6859-8.429-4.138-.3066.613-.5365 1.3027-.5365 2.069 0 1.456.6897 2.682 1.839 3.3716-.6896 0-1.3026-.2299-1.9156-.5364v.0767c0 1.9923 1.3793 3.6015 3.295 3.9846-.3065.0767-.6897.1533-1.0728.1533-.2299 0-.5364 0-.7663-.0766.5364 1.6092 1.9924 2.8352 3.8314 2.8352-1.3793 1.0728-3.1417 1.7625-5.0574 1.7625-.3065 0-.6897 0-.9962-.0767 1.839 1.1495 3.9847 1.8391 6.2835 1.8391z"}));
}

Twitter.defaultProps = {"fill":"none","viewBox":"0 0 20 17"};

module.exports = Twitter;

Twitter.default = Twitter;
